import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import { currentResource } from '../../util/utils';
import _ from 'lodash';

export default function engagementUserRolesReducer(
	state = initialstate.roles,
	action
) {
	switch (action.type) {
		case types.GET_ALL_ENGAGEMENT_USER_ROLES:
			return getLocalizedRoles(action);
		default:
			return state;
	}
}


export function rbacUserRolesReducer(
	state = initialstate.rbacRoles,
	action
) {
	switch (action.type) {
		case types.GET_ALL_RBAC_USER_ROLES:
			return action.response;
		default:
			return state;
	}
}

function getLocalizedRoles(action) {
	let engagementUserRoles = [];

	var localizedEngagementUserRoles = currentResource.RoleForMember;
	_.each(action.response, function (apiRole) {
		let localRole = localizedEngagementUserRoles.find(
			(x) => x.id == apiRole.id
		);
		let finalName = localRole ? localRole.role : apiRole.name;
		engagementUserRoles.push({
			id: apiRole.id,
			name: finalName
		});
	});

	return engagementUserRoles;
}
